<style scoped lang="scss">
  .wrap-register{
    background: #F8F8F8;
    padding:40px 0;
    .container{
      background: #fff;
      width: 1000px;
      padding:40px 250px;
    }
    .title{
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 40px;
    }
    .el-cascader{
      width:100%;
    }
  }
  @media screen and (max-width: 640px){
    .wrap-register .container {
      width: 100% !important;
      padding: 10% 10% 0 0!important;
    }
    .wrap-register {
      padding: 20px!important;
    }
    .btn{
      margin-left: -70px;
    }
    .form_a{
      padding-bottom: 10px;
    }
  }
</style>
<template>
  <div class="wrap wrap-register" :class="{'bg_white': showSuccess}">
    <section class="container" v-show="!showSuccess">
      <div class="title">欢迎注册擎科生物</div>
      <el-form :model="registerForm" ref="registerForm" :rules="registerFormRules" label-width="120px" class="form_a">
        <el-form-item label="单位信息" prop="company">
          <el-input v-model="registerForm.company"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="registerForm.name"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" required>
          <el-input v-model="registerForm.email" @change="getEmailRepeat('email', registerForm.email)"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" required>
          <el-input type="tel" v-model="registerForm.phone"  @change="getEmailRepeat('phone', registerForm.phone)"></el-input>
        </el-form-item>
        <el-form-item label="课题组" prop="remarks" required>
          <el-input type="tel" v-model="registerForm.remarks"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" prop="code">
          <el-input type="text" v-model="registerForm.code">
            <span slot="suffix" class="mr10 text-primary pointer" @click="getCode" v-if="timesCount === 0">发送验证码</span>
            <span slot="suffix" class="mr10 text-primary" v-else>{{timesCount}}s</span>
          </el-input>
        </el-form-item>
        <el-form-item label="地址选择" prop="address">
          <el-cascader
            v-model="registerForm.address"
            :options="cities"
            ref="myCascader"
            @change="handleAddressChange"></el-cascader>
        </el-form-item>
        <el-form-item label="登录密码" prop="password" required>
          <el-input type="password" v-model="registerForm.password" placeholder="请输入6位以上，包含数字，字母的密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passwordConfirm" required>
          <el-input type="password" v-model="registerForm.passwordConfirm" placeholder="请输入确认密码"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddress">
          <el-input type="text" v-model="registerForm.detailAddress"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="onSubmit('registerForm')">立即注册</el-button>
          <div class="fr">已有账号？<router-link to="/login">去登录</router-link></div>
        </el-form-item>
      </el-form>
    </section>
    <div class="success" v-show="showSuccess">
      <img src="@/assets/images/icon_success.png">
      <h2>注册成功</h2>
      <router-link to="/login">立即登陆</router-link>
    </div>
  </div>
</template>

<script>
import { register, isEmailRepeat } from '@/services/api.index'
import { getRegionTreeData } from '@/utils'
export default {
  data () {
    let checkMobile = (rule, value, callback) => {
      this.baseMethods.checkPhoneRules(value, callback)
    }
    let checkEmail = (rule, value, callback) => {
      this.baseMethods.checkEmailRules(value, callback)
    }
    let checkPassword = (rule, value, callback) => {
      this.baseMethods.checkPasswordRules(value, callback, 'password')
    }
    let checkPasswordConfirm = (rule, value, callback) => {
      this.baseMethods.checkPasswordRules(value, callback, 'passwordConfirm')
    }
    return {
      showSuccess: false,
      registerForm: {
        company: '',
        name: '',
        email: '',
        phone: '',
        code: '',
        address: [],
        addressLabel: [],
        password: '',
        passwordConfirm: '',
        detailAddress: '',
        remarks: '',
        errorMessageEmail: '',
        errorMessagePhone: ''
      },
      cities: [],
      timesCount: 0,
      registerFormRules: {
        company: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [{ validator: checkEmail, trigger: 'blur' }],
        phone: [{ validator: checkMobile, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        address: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        password: [{ validator: checkPassword, trigger: 'blur' }],
        passwordConfirm: [{ validator: checkPasswordConfirm, trigger: 'blur' }],
        detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        remarks: [{ required: true,message: '请输入课题组', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.getRegionInfo()
  },
  methods: {
    async getRegionInfo() {
      const res = await getRegionTreeData()
      this.cities = res
    },
    handleAddressChange () {
      this.registerForm.addressLabel = this.$refs['myCascader'].getCheckedNodes()[0].pathLabels
    },
    // 发送验证码
    getCode () {
      const { phone } = this.registerForm
      this.baseMethods.sendCode(phone, 'registerForm', this)
    },
    onSubmit (formName) {
      if(this.errorMessageEmail!=='') {
        this.$message({
          message: this.errorMessageEmail,
          type: 'warning'
        });
        return
      }
      if(this.errorMessagePhone!=='') {
        this.$message({
          message: this.errorMessagePhone,
          type: 'warning'
        });
        return
      }
      const { company, name, email, phone, code, address, addressLabel, password, passwordConfirm, detailAddress, remarks } = this.registerForm
      console.log(phone)
      if (passwordConfirm !== password) {
        this.$message.error('两次密码输入不一致')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          register(code, addressLabel[0], address[0], addressLabel[1], address[1], detailAddress, email, passwordConfirm, phone, password, name, company, remarks).then(() => {
            this.showSuccess = true
          })
        }
      })
    },
    getEmailRepeat (type, value) {
      isEmailRepeat(type, value).catch(error => {
        if(error.title==="手机号已被其他账号绑定，请替换") {
          this.errorMessagePhone = error.title
        }else if(error.title==="邮箱已被其他账号绑定，请替换"){
          this.errorMessageEmail = error.title
        }
      }).then(res => {
          if(res && res.data == true) {//邮箱
            this.errorMessageEmail = ''
          }else if(res && res.data == false){//手机号
            this.errorMessagePhone = ''
          }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/register.vue